/**
 * 判断是否是移动端
 * 通过判断 userAgent 中是否包含常见的移动设备标识来判断
 * @returns
 */
export const checkIsMobile = () => {
  const ua = navigator.userAgent;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    ua
  );
};

let instanceId = null;
/**
 * 生成唯一的客户端ID，页面刷新后会变更
 * @returns
 */
export const getInstanceId = () => {
  if (instanceId) {
    return instanceId;
  }
  instanceId =
    "cli_" + Date.now() + "_" + Math.random().toString(36).substr(2, 8);
  return instanceId;
};
